<template>
    <div>
        <div>
            <p>Below is your updated Address information. Please click 'Submit' to update your address on your RI DMV Customer record. To make change click on 'Previous'.</p>
            <p>You will receive an address change confirmation at the email on file with the DMV.</p>
            <p>
                <strong>Please note:</strong> You do not need a updated driver's license or registration certificate as a result of this address change. Visit your local RI DMV branch if you wish to obtain a new one with your updated address.
            </p>
            <div class="app-confirm-address">
                <div>
                    <h2>
                        Physical Address
                    </h2>
                    <UserAddress :addressDetails="userPhysicalAddress"/>
                </div>
                <div>
                    <h2>
                        Mailing Address
                    </h2>
                    <UserAddress :addressDetails="userMailingAddress"/>
                </div>
            </div>
            <div class="voter-reg">
                <input type="checkbox" id="voterRegistration" v-model="updateVoterRegAddress">
                <label for="voterRegistration">
                    If you are registered to vote in RI, we will use your Physical address to update where you are registered to vote. 
                    If you do not wish to update your voter registration address, please check this box.
                </label>
            </div>
        </div>
        <BaseButtonGroup>
            <button type="button" @click="handleRouting('previous')">Previous</button>
            <CustomButton @click="handleRouting('next')">
                Submit
            </CustomButton>
        </BaseButtonGroup>
    </div>
</template>


<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import * as COMMONS from '../../store/_commons';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import CustomButton from '../CustomButton.vue';
import UserAddress from './UserAddress.vue';

// Store
const store = useStore();

// Reactive State 
const updateVoterRegAddress = ref(false);

// Computed Properties 
const personalInfo = computed(() => store.getters[COMMONS.GUEST_PERSONAL_INFO]);

const userPhysicalAddress = computed(() => {
    if (store.state.guestLogin.physicalAddressType == 'standardPhysicalAddress') {
        return store.state.guestLogin.standardPhysicalAddress;
    }
    return store.state.guestLogin.userPhysicalAddress;
});

const userMailingAddress = computed(() => {
    if (store.state.guestLogin.mailingAddressType == 'standardMailingAddress') {
        return store.state.guestLogin.standardMailingAddress;
    }
    return store.state.guestLogin.userMailingAddress;
});

// Methods
const postConfirmAddress = (payload) => store.dispatch(COMMONS.GUEST_CONFIRM_ADDRESS, payload);

const handleRouting = async (info) => {
    if (info == 'previous') {
        if (store.state.guestLogin.skipStepTo) {
            store.state.guestLogin.addressUpdateStep = 1;
        } else {
            store.state.guestLogin.addressUpdateStep = 2;
        }
    } else if (info == 'next') {
        const payloadData = {
            doNotUpdateVoterRegistrationAddress: updateVoterRegAddress.value,
            isSameAddressForMailing: store.state.guestLogin.physicalMailingAddressCheck,
            mailingAddress: {
                addressLine1: userMailingAddress.value.addressLine1,
                addressLine2: userMailingAddress.value.addressLine2,
                addressType: personalInfo.value.personalInformation.mailingAddress.addressType,
                city: userMailingAddress.value.city,
                country: personalInfo.value.personalInformation.mailingAddress.country,
                internationalZipCode: personalInfo.value.personalInformation.mailingAddress.internationalZipCode,
                province: personalInfo.value.personalInformation.mailingAddress.province,
                state: userMailingAddress.value.stateId.toString(),
                zipCode: userMailingAddress.value.zipCode,
                zipPlus: userMailingAddress.value.zipPlus,
            },
            physicalAddress: {
                addressLine1: userPhysicalAddress.value.addressLine1,
                addressLine2: userPhysicalAddress.value.addressLine2,
                addressType: personalInfo.value.personalInformation.physicalAddress.addressType,
                city: userPhysicalAddress.value.city,
                country: personalInfo.value.personalInformation.physicalAddress.country,
                internationalZipCode: personalInfo.value.personalInformation.physicalAddress.internationalZipCode,
                province: personalInfo.value.personalInformation.physicalAddress.province,
                state: userPhysicalAddress.value.stateId.toString(),
                zipCode: userPhysicalAddress.value.zipCode,
                zipPlus: userPhysicalAddress.value.zipPlus,
            },
        };
        await postConfirmAddress(payloadData);
    }
};

onMounted(() => {
    window.scrollTo(0, 0);
    document.body.setAttribute("tabindex", "1");
    document.body.focus();
    document.body.removeAttribute("tabindex");
    document.getElementById("app").scrollTop = 0;
});
</script>


<style scoped lang="scss">
.app-address-info{
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 1rem;
  .app-input-address{
    display: block;
    .app-user-address-info{
      display: flex;
      gap: 2rem;
    }
    .app-user-address{
      margin-bottom: 1rem;
      display: flex;
      .user-address-info{
        min-width: 275px;
      }
      .diff{
        padding: 0.5rem;
      }
      .zip-selection {
        width: 106px !important;
      }
      .user-address-info-zipplus {
        max-width: 100px;
      }
      .user-address-info-gray{
        background: lightgray;
      }
    }
  }
}
.app-confirm-address{
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    margin-top: 1rem;

    h2 {
        font-size: 1rem;
        font-family: "Work Sans", sans-serif;
    }
}
.voter-reg {
    label {
        display: block;
        margin-left: 1rem;
    }
    input {
        float: left;
        height: 20px;  
    }
}
button {
    margin-bottom: 1.125em;
    &:not(:last-child) {
    margin-right: 1em;
    }
    &.disabled {
    cursor: not-allowed;
    opacity: 0.7;
    }
}
@media only screen and (max-width: 510px) {
  .app-address-info{
    .app-input-address{
      display: block;
      .app-user-address-info{
        display: block;
      }
      .app-user-address{
        .user-address-info{
          min-width: 300px;
        }
        .user-address-info-city {
          width: 200px;
        }
        .zip-selection {
          width: 106px !important;
        }
        .user-address-info-zipplus {
          max-width: 100px;
        }
      }
    }
  }
}
</style>